<template>
  <span>
    <v-text-field v-if="!button"
      :label="label"
      :value="display"
      prepend-icon="mdi-file-document"
      :append-icon="previewable ? 'mdi-magnify' : null"
      @click:append="preview"
      @click="$refs.document.click()"
      :loading="loading"
      :color="color"
    />
    <v-btn v-if="button" block :color="color" @click="$refs.document.click()">
      {{ label }} <v-icon right>mdi-cloud-upload</v-icon>
    </v-btn>
    <input
      type="file" name="document" ref="document"
      style="display: none"
      @change="setFile"
    />

    <v-dialog v-model="previewing" max-width="600px" lazy>
      <v-card v-if="previewable" :dark="dark">
        <v-card-title
          class="subheading"
          :class="theme ? theme.dialogTitle : ''"
        >
          {{ label }} Preview
        </v-card-title>
        <v-img
          v-if="isImage"
          height="800px"
          :style="`background: center no-repeat url('${value.url}'); background-size: contain;`"
        />
        <v-img v-else>
          <iframe :src="value.url" height="800px" width="100%" style="border: 0;"></iframe>
        </v-img>
        <v-card-actions><v-spacer />
          <v-btn color="secondary" @click="previewing = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
// Vue Component
export default {
  props: {
    // Properties for configuring the input
    label: { type: String, default: () => 'Document' },
    color: { type: String, default: () => 'primary' },
    button: { type: Boolean, default: () => false },
    // Properties for configuring the modal
    theme: { type: Object },
    dark: { type: Boolean, default: () => false },
    // The String URI to the current document or the File if it has been added recently
    value: { type: [Object, File] },
    // The URI where the document should be posted if it is set to auto-submit
    action: { type: String },
    autoSubmit: { type: Boolean }
  },
  data() {
    return {
      loading: false,
      previewing: false
    }
  },
  computed: {
    display() {
      if (typeof this.value === 'undefined') {
        return ''
      } else if (typeof this.value === 'object') {
        const segments = this.value.url.split('/')
        return segments[segments.length - 1]
      } else if (typeof this.value === 'file') {
        return this.value.name
      }
    },
    isImage() {
      if (typeof this.value === 'object') {
        return /^image\//.test(this.value.content)
      } else {
        return false
      }
    },
    previewable() {
      return typeof this.value === 'object'
    }
  },
  methods: {
    preview() {
      if (typeof this.value === 'object') {
        this.previewing = true
      }
    },
    setFile() {
      if (this.autoSubmit) {
        const formData = new FormData()
        formData.append('document', this.$refs.document.files[0])
        this.loading = true
        this.$http
          .post(this.action, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            this.$emit('submit')
            this.loading = false
          })
      } else {
        this.$emit('input', this.$refs.document.files[0])
      }
    },
    remove() {
      if (this.autoSubmit) {
        this.loading = true
        this.$http
          .post(this.action, { document: null }, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            this.$emit('success')
            this.loading = false
          })
      } else {
        this.$emit('input', null)
      }
    }
  }
}
</script>
